class TimelineItems extends window.BAO.CustomElement() {
  static get requiredElements () {
    return ['toggle', 'item']
  }

  setupListeners () {
    super.setupListeners()

    this.onToggle = this.onToggle.bind(this)

    this.els.toggle.elements.forEach(toggle => {
      toggle.addEventListener('click', this.onToggle)
    })
  }

  onToggle (event) {
    this.els.item.elements.forEach(item => {
      item.isActive = !item.isActive
    })

    this.isShowingAll = !this.isShowingAll

    this.setButtonState(event.target)
  }

  setButtonState (buttonEl) {
    buttonEl.innerHTML = this.isShowingAll
      ? buttonEl.dataset.hide
      : buttonEl.dataset.show
  }
}

class TimelineItem extends window.BAO.CustomElement() {
  get isActive () {
    return this.hasAttribute('active')
  }

  set isActive (val) {
    val ? this.setAttribute('active', '') : this.removeAttribute('active')
  }
}

class TimelineAccordion extends window.BAO.CustomElement() {
  static get requiredElements () {
    return ['trigger', 'panel']
  }

  static get styles () {
    return `
      :host {
        display: block;
        
        overflow: hidden;
      }
    `
  }

  setupListeners () {
    super.setupListeners()

    this.onTriggerClick = this.onTriggerClick.bind(this)

    this.listeners.add(this.els.trigger.element, 'click', this.onTriggerClick)
  }

  onTriggerClick (event) {
    this.isOpen = !this.isOpen

    this.setButtonState(event.target)
  }

  setButtonState (buttonEl) {
    buttonEl.innerHTML = this.isOpen
      ? buttonEl.dataset.readLess
      : buttonEl.dataset.readMore
  }

  get isOpen () {
    return this.hasAttribute('open')
  }

  set isOpen (val) {
    val ? this.setAttribute('open', '') : this.removeAttribute('open')

    this.els.panel.element.setAttribute('aria-expanded', val.toString())
  }
}

if (!customElements.get('timeline-items')) {
  customElements.define('timeline-items', TimelineItems)
}

if (!customElements.get('timeline-item')) {
  customElements.define('timeline-item', TimelineItem)
}

if (!customElements.get('timeline-accordion')) {
  customElements.define('timeline-accordion', TimelineAccordion)
}
